import React from 'react'
import { Image, Button } from 'antd'
import { useTranslation } from 'react-i18next'

import dynamicPhotoPic from '@/assets/images/dyeximg.png'
import dynamicPhotoShape from '@/assets/images/dynamic-photo-shape.png'
import dynamicPhotoTransform from '@/assets/images/transform.png'
import dynamicPhotoBg from '@/assets/images/bg-shape.svg'
import dynamicPhotoGIF from '@/assets/images/dyexgif.gif'

import { ReactComponent as CloseIcon } from '@/assets/icons/close.svg'

import '@/assets/dynamicPhoto.less'

const DynamicPhotoWorkRender = ({ currFile, handleCloseFile, handelNextStep }) => {
  const { t } = useTranslation(['dynamicPhoto'])

  return (
    <div className="workplace-cont">
      <div className="workplace-cont-lft">
        <div className="workplace-cont-image">
          <CloseIcon
            style={{ color: 'rgb(176 174 174)' }}
            className="clost-icon"
            onClick={handleCloseFile}
          />
          <Image src={currFile.videofileurl} preview={false} />
        </div>
        <Button type="primary" size="large" onClick={() => handelNextStep(1)}>
          {t('Next')}
        </Button>
      </div>
      <div className="workplace-cont-rgt">
        <img src={dynamicPhotoBg} className="staic-bg" alt="dynamic" />
        <div className="static">
          <img className="transfrom-icon" src={dynamicPhotoTransform} alt="dynamic" />
          <img className="static-pic" src={dynamicPhotoPic} alt="dynamic" />
          <img className="shape" src={dynamicPhotoShape} alt="dynamic" />
        </div>
        <img className="dynamic" src={dynamicPhotoGIF} alt="dynamic" />
      </div>
    </div>
  )
}

export default DynamicPhotoWorkRender
